import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const SelectContentDisposition = props => {
  return <LazyLoaderWrapper importPath='CONTENT_DISPOSITION_ITEMS' {...props} />;
};

export default SelectContentDisposition;
